import { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import './Background.css';
import Card from '../Card/Card';
import { BackgroundColorSnippet, ColorSnippet } from '../../snippets/ColorSnippet/ColorSnippet';
import { Copy } from 'lucide-react';

const Background = () => {
  // Refs for Background
  // const dayRef = useRef(null);
  // const nightRef = useRef(null);
  // const mainRef = useRef(null);
  // const viceRef = useRef(null);

  // useEffect(() => {
  //   const setFontColorBasedOnBackground = (element) => {
  //     if (element) {
  //       const bgColor = window.getComputedStyle(element).backgroundColor;
  //       const lum = getLuminance(bgColor);

  //       // Use a threshold value to determine whether to use light or dark text
  //       const threshold = 0.5;
  //       const fontColor = lum > threshold ? 'black' : 'white';

  //       element.style.color = fontColor;
  //     }
  //   };

  //   setFontColorBasedOnBackground(dayRef.current);
  //   setFontColorBasedOnBackground(nightRef.current);
  //   setFontColorBasedOnBackground(mainRef.current);
  //   setFontColorBasedOnBackground(viceRef.current);
  // }, []);

  // const getLuminance = (color) => {
  //   const rgb = color.match(/\d+/g);
  //   if (!rgb) return 0;

  //   const lum = 0.2126 * rgb[0] / 255 + 0.7152 * rgb[1] / 255 + 0.0722 * rgb[2] / 255;
  //   return lum;
  // };

  const snippetContainerRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };

  const colorSnipContRef = useRef(null);
  const [showColorScanning, setColorScan] = useState(false)
  const copyColorSnippet = () => {
    if (colorSnipContRef.current) {
      const range = document.createRange();
      range.selectNode(colorSnipContRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setColorScan(true);
      setTimeout(() => setColorScan(false), 1000);
    }
  };

  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <>
        <div className='heading-medium'> <u>Background</u> </div>
        <div className="Background">
          {/* Background Snippet */}
          <div className='wall carve-wall-day' >
            day
          </div>
          <div className='wall carve-wall-night' style={{ color: 'var(--day)' }} >
            night
          </div>
          <div className='wall carve-wall-main' style={{ color: 'var(--day)' }}>
            main
          </div>
          <div className='wall carve-wall-vice' >
            vice
          </div>
        </div>
        <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

          <div className='snippet' ref={snippetContainerRef}>
            <BackgroundColorSnippet />
          </div>
          <button aria-label="Copy Button" onClick={copySnippet}>
            <Copy />
          </button>

        </div>
      </>
      <>
        <div className='heading-medium' style={{ marginTop: '5rem' }}> <u>Colors</u> </div>
        <div className="Colors">
          {/* Color Snippet */}
          <div className='carve-text-main'>
            main
          </div>
          <div className='carve-text-vice carve-wall-night'>
            vice
          </div>
          <div className='carve-text-body'>
            body
          </div>
          <div className='carve-text-body2'>
            body2
          </div>
          <div className='carve-text-day carve-wall-night'>
            day
          </div>
          <div className='carve-text-night'>
            night
          </div>
        </div>
        <div className={`center-container ${showColorScanning ? 'scanning' : ''}`}>

          <div className='snippet' ref={colorSnipContRef}>
            <ColorSnippet />
          </div>
          <button aria-label="Copy Button" onClick={copyColorSnippet}>
            <Copy />
          </button>
        </div>
      </>
    </motion.div>
  );
};

const BackgroundCard = () => {
  return (
    <Card
      CardTitle='Colors & Backgrounds'
      CardBody={<Background />}
    />
  );
};

Background.propTypes = {};

export default BackgroundCard;
